module.exports = __webpack_public_path__ + "img/award_badge_long_best_2024.c56cfeae.png";